import type { WorksForContent } from "../types";

export const worksFor: WorksForContent = {
  leadIn: "UCloud AI works for",
  words: [
    "biologists",
    "coding",
    "humanists",
    "literature reviews",
    "clinicians",
    "data analysis",
    "physicists",
    "grant writing",
    "engineers",
    "summarising documents",
    "students",
    "transcriptions",
    "teachers",
    "brainstorming",
    "presentations",
    "Everyone!",
  ],
};
